import { type FireAnalyticsEvent } from '../../types';

import { type CommonAttributes } from './types';

type FullPageSearchOperationalAnalyticsProps = {
	success: boolean;
	commonAttributes: CommonAttributes;
};

export const onFullPageSearchOperational = ({
	success,
	commonAttributes,
}: FullPageSearchOperationalAnalyticsProps): FireAnalyticsEvent => ({
	eventType: 'operational',
	action: success ? 'taskSuccess' : 'taskFail',
	actionSubject: 'ui',
	attributes: {
		commonAttributes,
		additionalAttributes: {
			task: 'unifiedSearch',
			capability: 'fullPageSearchResult',
			// This edition is not exact matching the need for the AutoHots
			// A follow up is to find the current primary product edition and log that.
			// Currently we only have confluence edition in the productEdition object, so logging the entire object for now.
			edition: commonAttributes.productEdition,
			// Confirmed with AutoHots team this is mandatory
			// and base on "Can I log this" doc, we can log this.
			// https://hello.atlassian.net/wiki/spaces/Monitoring/pages/5816497997/Vitalstats+Onboarding+contract?focusedCommentId=5864073069
			// https://hello.atlassian.net/wiki/spaces/SECURITY/pages/236070634/Can+I+Log+This
			hostname: window.location.hostname,
		},
	},
});
